import React from "react";
import '../components-render/component_styles/description.scss'

export default function DescriptionRender({description_data,numberic,imgSrc}){
    // console.log(imgSrc); 
    return(
        <div className="des-container">

            <div className="des-title">
                <h4>{numberic!==false?`${numberic+1}. `:''}{description_data.title}</h4>
            </div>
            {
                description_data.content&&
                    <div className="des-content">
                    
                        {description_data.content.split('/br/').filter(cont=>cont!=='').map((cont,index)=>{
                            return(
                                <p>{numberic?`${index+1} - `:''}{cont}</p>
                            )
                        })}
                        
                    </div>
            }
            
            {description_data.img&&
            
            
                <div className="des-img">

                    {description_data.img.split('##').map((src,index)=>{
                        return(
                            <img src={imgSrc?.[index]} alt="Ảnh minh họa"></img>
                        )
                    })}
                </div>
            }
        </div>
    )
}